import React from "react";
import styles from './index.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div>
        Copyright © {new Date().getFullYear()} MyLottery LK. All Rights Reserved.
        Designed and Developed by{" "}
        <a
          href="https://prideconsultationcenter.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          Pride CC
        </a>.
      </div>
    </footer>
  );
};

export default Footer;